<template>
    <div id="removeclass">
      <modal
        :modal-id="modalId"
        :title="modalTitle"
        :preloader="preloader"
        @submit="submit"
        @close-modal="closeModal"
      >
        <template slot="body">
          <app-overlay-loader v-if="preloader" />
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="selectedUrl ? `crud/${inputs.id}` : addurl">
            <div class="form-group row align-items-center">
              <div class="col-sm-12 mb-3">
                <label for="inputs_category" >{{ $t("category") }}</label>
                <app-input
                  id="inputs_category"
                  type="search-select"
                  :placeholder="$t('select_category')"
                  v-model="inputs.response_category_id"
                  :list="category"
                  :required=true
                />
                <!-- <p class="font-italic text-muted">
                  {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
                </p> -->
              </div>
            </div>
          </form>
        </template>
      </modal>
    </div>
  </template>
  
  <script>
  import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
  import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
  import { axiosPost, axiosGet } from "../../../../Helpers/AxiosHelper";
  import { RESPONSE_CATEGORY_STORE, RESPONSE_CATEGORY_FILTER_LIST, SAVE_RESPONSE_CATEGORY_IMPORT} from "../../../../Config/ApiUrl";
  import AppLibrary from "../../../../Helpers/AppLibrary";
  
  export default {
    name: "AddModal",
    extends: AppLibrary,
    mixins: [FormMixin, ModalMixin],
    props: {
      tableId: String,
      formRevisionId: Number,
    },
    data() {
      return {
        addurl:SAVE_RESPONSE_CATEGORY_IMPORT,
        preloader: false,
        inputs: {},
        category: [],
        modalId: "demo-save-response-category-import-modal",
        modalTitle: this.$t("import"),
      }
    },
    created() {
    },
    methods: {
      submit() {

        this.inputs.form_revision_id = this.formRevisionId;
        let formData = new FormData();
          Object.keys(this.inputs).forEach((key) => {
            formData.append(key,this.inputs[key]);
          });

        this.save(formData);
      },
      afterSuccess(response) {
        this.$toastr.s(response.data.message);
        this.$hub.$emit("reload-" + this.tableId);
      },

      getCategories() {
        axiosGet(RESPONSE_CATEGORY_FILTER_LIST)
          .then((res) => {
            this.category = res.data;
          })
          .catch((error) => {
            
          });
      },
    },
    mounted() {
      
      this.getCategories();
      $(function () {
        $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
      });
    },
  };
  </script>
  